import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { fmtEur, fmtDate, openGedDoc } from './gedUtils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/paiements-cb/admin/domium-paiements`;

export const PaiementsDomiumESS = () => {
  const { getAuthHeader } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(API, { headers: getAuthHeader() }).then((r) => setData(r.data)).catch(() => setData({ items: [], error: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-slate-400" />;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="paiements-domium-ess">
      <p className="text-sm text-slate-600" data-testid="paiements-domium-synthese">{data.items.length} paiement(s) DOS-DOMIUM · total encaissé <strong>{fmtEur(data.total)}</strong></p>
      {data.items.length === 0 ? <p className="text-sm text-slate-500 py-6 text-center">Aucun paiement DOS-DOMIUM.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase text-slate-500 border-b"><th className="py-2 pr-2">Date</th><th className="pr-2">Demandeur</th><th className="pr-2">Devis</th><th className="pr-2">Mode</th><th className="pr-2 text-right">Montant</th><th className="pr-2 text-right">Reste dû</th><th className="pr-2">État</th><th>Reçu</th></tr></thead>
            <tbody>
              {data.items.map((i, k) => (
                <tr key={k} className="border-b last:border-0" data-testid={`domium-paiement-row-${k}`}>
                  <td className="py-2 pr-2 tabular-nums">{fmtDate(i.date)}</td>
                  <td className="pr-2"><div className="font-medium text-slate-900">{i.nom}</div><div className="text-xs text-slate-500">{i.email}</div></td>
                  <td className="pr-2 text-xs">{i.reference}</td>
                  <td className="pr-2 text-xs">CB {i.mode === '4x' ? 'en 4 fois' : 'en 1 fois'}{i.auto ? ' · prélèvement auto' : ''}</td>
                  <td className="pr-2 text-right tabular-nums font-semibold">{fmtEur(i.montant)}</td>
                  <td className="pr-2 text-right tabular-nums">{fmtEur(i.reste)}</td>
                  <td className="pr-2 text-xs">{i.etat_label || '—'}</td>
                  <td>
                    <button type="button" disabled={!i.ged_id} onClick={() => openGedDoc(i.ged_id, getAuthHeader())} data-testid={`domium-paiement-recu-${k}`}
                      className="inline-flex items-center gap-1 text-xs text-emerald-700 hover:underline disabled:opacity-40"><FileText className="h-3.5 w-3.5" /> {i.recu_numero || 'Reçu'}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
